import React, { FC } from 'react';
import { CircularProgress, Dialog } from 'drift-ui';
import { useTranslation } from 'react-i18next';
import style from './RemoveOwnerModal.scss';

export const RemoveOwnerModal: FC<{
  show: boolean;
}> = ({ show }) => {
  const { t } = useTranslation();
  return (
    <Dialog open={show}>
      <div className={style.dialogContainer}>
        <h2 className={style.headerTitle}>{t('remove_owner_title')}</h2>
        <div className={style.container}>
          <CircularProgress size={56} />
        </div>
      </div>
    </Dialog>
  );
};

export default RemoveOwnerModal;
